import { Component, OnInit, HostListener, ViewChild } from '@angular/core';
import { Router } from '@angular/router';

import { AutoRedirectRule } from '../../../models/auto-redirect-rule';

import { AutoRedirectRuleService } from '../../../services/auto_rules/auto-redirect-rule.service';
import { NotyService } from '../../../services/common/noty.service';

import { MatterSearchComponent } from '../../common/matter-search/matter-search.component';
import { DocumentTypeSearchComponent } from '../../common/document-type-search/document-type-search.component';

declare var swal: any;

@Component({
  selector: 'app-auto-redirect-rule-index',
  templateUrl: './auto-redirect-rule-index.component.html',
  styleUrls: ['./auto-redirect-rule-index.component.scss'],
})
export class AutoRedirectRuleIndexComponent implements OnInit {
  @ViewChild('sidebar_matter_search', { static: true }) sidebarMatterSearch: MatterSearchComponent;
  @ViewChild('sidebar_document_type_search', { static: true }) sidebarDocumentTypeSearch: DocumentTypeSearchComponent;

  autoRedirectRules: Array<AutoRedirectRule> = [];

  deletingAutoRedirectRule: boolean = false;

  count: number = 0;

  loading: boolean = true;

  searchParams: any = { per_page: 20 };

  selectedAutoRedirectRule: AutoRedirectRule;

  /**
   * Indicates if sidebar is to be shown for smaller width screens
   * @type {boolean}
   */
  sidebarOpen: boolean = false;

  constructor(private notyService: NotyService, private router: Router, private autoRedirectRuleService: AutoRedirectRuleService) {}

  // Component lifecycle methods
  ngOnInit() {
    this.loading = true;
    this.autoRedirectRuleService
      .searchOptions()
      .then((response_json) => {
        this.searchParams = response_json;
        this.loadAutoRedirectRules();
      })
      .catch(() => {
        this.loadAutoRedirectRules();
      });
    this.setInitialSidebarPosition();
  }

  // Event Listeners
  @HostListener('window:scroll', ['$event'])
  window_scroll(event: Event) {
    this.content_sidebar_scroll();
    this.search_height_maintainer();
  }

  @HostListener('window:resize', ['$event'])
  window_resize(event: Event) {
    this.content_sidebar_scroll();
    this.search_height_maintainer();
  }

  // Component methods
  clearSearch() {
    this.searchParams.document_type_id = null;
    this.searchParams.matter_id = null;
    if (this.sidebarMatterSearch) this.sidebarMatterSearch.clearSelectedMatter();
    if (this.sidebarDocumentTypeSearch) this.sidebarDocumentTypeSearch.clearSelectedDocumentType();
  }

  deleteAutoRedirectRule(autoRedirectRule: AutoRedirectRule) {
    let scope: AutoRedirectRuleIndexComponent = this;
    swal({
      title: 'Remove Auto Redirect Rule',
      text: `Remove Auto Redirect Rule ${autoRedirectRule.id} ?`,
      icon: 'warning',
      dangerMode: true,
      buttons: {
        cancel: {
          text: 'No',
          value: false,
          visible: true,
          className: '',
          closeModal: true,
        },
        confirm: {
          text: 'Yes',
          value: true,
          visible: true,
          className: '',
          closeModal: true,
        },
      },
    })
      .then((confirmed: any) => {
        if (confirmed) {
          this.deletingAutoRedirectRule = true;
          this.autoRedirectRuleService
            .delete(autoRedirectRule.id)
            .then((response) => {
              this.deletingAutoRedirectRule = false;
              if (response.success) {
                this.notyService.notify(response.text || `Removed auto redirect rule ${autoRedirectRule.id}`, 'warning');
                this.loadAutoRedirectRules();
              } else {
                this.notyService.notify(response.text || 'Error removing auto redirect rule', 'error');
              }
            })
            .catch(() => {
              scope.deletingAutoRedirectRule = false;
              scope.notyService.notify('Error removing auto redirect rule', 'error');
            });
        }
      })
      .catch((err: any) => {
        console.log('Delete prompt error', err);
      });
  }

  loadAutoRedirectRules() {
    this.loading = true;
    this.autoRedirectRuleService
      .index(this.searchParams)
      .then((response_json) => {
        this.loading = false;
        this.count = response_json.count;
        this.autoRedirectRules = response_json.auto_redirect_rules;
      })
      .catch(() => {
        this.loading = false;
      });
  }

  newAutoRedirectRule() {
    this.router.navigateByUrl('/auto_redirect_rules/new');
  }

  search(pageNumberEvent: any = null) {
    if (pageNumberEvent) this.searchParams.page = pageNumberEvent.page;
    this.loadAutoRedirectRules();
  }

  // Functions for UI manipulation using vanilla JS or jQuery

  content_sidebar_scroll() {
    var content_main = document.getElementById('content-main');
    var content_sidebar = document.getElementById('content-sidebar');
    var sidebar_height = window.innerHeight;
    if (content_sidebar && content_main) {
      if (content_main.getBoundingClientRect().top > 19) {
        content_sidebar.style.position = 'absolute';
        content_sidebar.style.top = content_main.offsetTop + 10 + 'px';
        sidebar_height -= content_main.getBoundingClientRect().top + 40;
        //console.log('greater ' + matter_sidebar.style.top);
      } else {
        content_sidebar.style.position = 'fixed';
        content_sidebar.style.top = '20px';
        sidebar_height -= content_sidebar.getBoundingClientRect().top + 40;
        //console.log('lesser ' + matter_sidebar.style.top);
      }
      if (content_sidebar.clientHeight != sidebar_height) content_sidebar.style.height = sidebar_height + 'px';
    }
  }

  search_height_maintainer() {
    var content_sidebar = document.getElementById('content-sidebar');
    var content_search = document.getElementById('search-form');
    if (content_sidebar && content_search) {
      var search_height = content_sidebar.clientHeight - 157;
      if (search_height > 0) content_search.style.height = search_height + 'px';
      else content_search.style.height = '0px';
    }
  }

  setInitialSidebarPosition() {
    this.content_sidebar_scroll();
    this.search_height_maintainer();
    let sidebar_position = () => {
      this.content_sidebar_scroll();
      this.search_height_maintainer();
    };
    for (var i = 1; i < 20; i += 1) setTimeout(sidebar_position, (i * 1000) / 2);
  }
}
